<script>

import * as types from '../../../../store/mutation-types';

import CollapsibleItem from '../../../list/collapsible-item.vue';
import CollapsibleList from '../../../list/collapsible-list.vue';
import ProjectImagesModal from '../map/components/project-images-modal.vue';

export default {
  props: ['foundation', 'activeProject', 'opened'],
  components: {
    CollapsibleItem,
    CollapsibleList,
    ProjectImagesModal,
  },
  data() {
    return {
      modalItems: [],
      modalActiveItem: null,
      selectedValue: null,
      activeAlarmSectionTitle: null,
      loadingCheck: false,
    };
  },
  computed: {
    modalOpen() {
      return this.$store.state.ui.projectImagesModalOpen;
    },
    activeProjectGroup() {
      return this.$store.getters.activeProjectGroup;
    },
    faces() {
      return this.activeProject.latestPurchases
        .map(purchase => {
          const plotWithPicture = purchase.plots.find(plot => plot.purchasePhoto);

          return {
            name: purchase.name,
            photo: plotWithPicture.purchasePhoto,
          };
        });
    },
    sortedPictures() {
      const mainPicture = this.activeProject.mainPicture;
      const sortedPictures = this.activeProject.projectPictures;
      const filteredPictures = sortedPictures.filter(({ id }) => id !== mainPicture.id);
      filteredPictures.unshift(mainPicture);

      return filteredPictures;
    },
    video() {
      const videoId = this._getYTVideoId(this.activeProject.youtubeUrl);
      if (!videoId) return null;

      return {
        image: this._getYTThumb(videoId),
        embed: this._getYTEmbed(videoId),
      };
    },
    activeAlarmSection() {
      return this.alarmSections.find(
        (alarmSection) => alarmSection.title === this.activeAlarmSectionTitle
      );
    },
    calendarAttributes() {
      const alarms = this.activeAlarmSection && this.alarms(this.activeAlarmSection.id).map(alarm => ({
        key: `alarm-${alarm.id}`,
        dot: 'green',
        dates: alarm.date,
        customData: alarm.id,
      }));
      const popovers = {
        key: 'popovers',
        dates: {},
        popover: {
          visibility: 'click',
          isInteractive: true,
        },
      };

      return alarms ? [...alarms, popovers] : [popovers];
    },
    checklists() {
      return this.$store.getters.activeProjectChecklists;
    },
    alarmSections() {
      return this.$store.getters.activeProjectAlarmSections;
    },
    buttonText() {
      if (this.activeProject.customButtonText){
        return this.activeProject.customButtonText;
      }
      return this.$t('messages.sidebar.zoomProjectBtn');
    }
  },
  methods: {
    toggle() {
      this.$emit('toggle', !this.opened);
    },
    focusOn(project) {
      this.$store.dispatch('focusOnProject', project.id);
    },
    roundToTwoDecimals(num) {
      return Math.round((num + 0.00001) * 100) / 100;
    },
    openModal(items, index) {
      this.toggleModalStatus(true);
      this.modalItems = items;
      this.modalActiveItem = index;
    },
    closeModal() {
      this.toggleModalStatus(false);
      this.modalItems = [];
    },
    toggleModalStatus(modalStatus) {
      this.$store.commit(types.TOGGLE_PROJECT_IMAGES_MODAL, modalStatus);
    },
    _getYTVideoId(url) {
      if (!url || typeof url !== 'string') return;

      /* https://github.com/regexhq/youtube-regex */
      /* eslint-disable */
      const regExp = /(?:youtube\.com\/\S*(?:(?:\/e(?:mbed))?\/|watch(?:.*)\?(?:\S*?&?v\=))|youtu\.be\/)([a-zA-Z0-9_-]{6,11})/;
      const match = url.match(regExp);

      return (match) ? match[1] : undefined;
      /* eslint-enable */
    },
    _getYTThumb(videoId) {
      return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
    },
    _getYTEmbed(videoId) {
      return `//youtube.com/embed/${videoId}`;
    },
    setActiveAlarmSectionTitle(title) {
      this.activeAlarmSectionTitle = title;
    },
    createAlarm(hidePopoverFunction) {
      hidePopoverFunction();
      this.$store.dispatch('createAlarm', {
        alarmSectionId: this.activeAlarmSection.id,
        date: this.selectedValue,
      });
    },
    destroyAlarm(hidePopoverFunction, day) {
      hidePopoverFunction();
      this.$store.dispatch('destroyAlarm', {
        alarmSectionId: this.activeAlarmSection.id,
        alarmId: this.dayAlarmAttribute(day).customData,
      });
    },
    dayAlarmAttribute(day) {
      return day.attributes.find(attr => attr.key.startsWith('alarm-'));
    },
    checks(checklistId) {
      return this.$store.getters.checklistChecks(checklistId);
    },
    alarms(alarmSectionId) {
      return this.$store.getters.alarmSectionAlarms(alarmSectionId);
    },
    toggleCheckValue(check) {
      if (this.loadingCheck) return;

      this.loadingCheck = true;
      this.$store.dispatch('updateCheck', { checkId: check.id, done: !check.done }).then(() => {
        this.loadingCheck = false;
      });
    },
  },
};
</script>
